




































import { Component, Prop, Vue } from 'vue-property-decorator';
import { look_up_ticket_number } from '@/api/ticket';

@Component({
  name: 'TicketSearchResult',
})
export default class extends Vue {
  @Prop({ required: true }) private data!: look_up_ticket_number.TicketInfo;

  get ticketTypeText() {
    if (
      (this.data.ticketType as look_up_ticket_number.TicketType) ===
      look_up_ticket_number.TicketType.BOOKING
    ) {
      return this.$t('Booking');
    } else if (
      (this.data.ticketType as look_up_ticket_number.TicketType) ===
      look_up_ticket_number.TicketType.INVENTORY
    ) {
      return this.$t('Inventory');
    } else {
      return this.$t('Unknown');
    }
  }
}
